import Vue from 'vue';
import ActivitySchedulesListPage from './activityScheduleList';
import DayInactivityIntervalsListPage from './dayIncativityIntervalsList';
import {
    ConsumptionsPage,
    ConsumptionsEditPage,
    ConsumptionsSubPacksPage,
    ConsumptionsRoutesPage,
    ConsumptionPerformancePage,
    ConsumptionReasonPage
} from './consumptions';
import { StocksMapPage, StocksPage } from './stocks';
import ChannelsListPage from './channelsList';
import ResourceTypesListPage from './resourceTypesList';
import { PlannedOperationsPage, PlannedOperationsDetailPage, OperationsChartPage } from './plannedOperations';
import { LogisticWorkplacePage } from './logisticWorkplace';
import OperationalPlanSummaryPage from './operationalPlanSummary';
import { RelocationsPage, RelocationsMapPage } from './relocations';
import ProductRelocationsPage from './productRelocations';
import ResourcesUsagePage from './resourcesUsage';
import { registerSettingsPages } from './settingsPage';
import ReplacementsPage from './replacements';
import GroupIndicatorsValuePage from './groupIndicators';
import LogPage from './log';
import UsersPage from './users';
import ProductsListPage from './productsList';
import LogisticsNetworkPage from './logisticsNetwork';
import RelocationLimitsPage from './relocationLimits';
import SitesListPage from './sitesList';
import TechesListPage from './teches';
import MicroeconomicsPage, { MicroeconomicsDetailsPage } from './microeconomics';
import VehiclesListPage from './vehiclesList';
import InactivityIntervalsListPage from './inactivityIntervals';
import UnavailabilityIntervalsListPage from './unavailabilityIntervals';
import CranesListPage from './cranesList';
import UsageResourcesPage from './usageResources';
import { LocationHistoryPage, LocationHistoryMap } from './locationHistory';
import CargoPlacementPage from './cargoPlacement';
import AuditPage from './audit';

export function registerPages() {
    registerSettingsPages();

    Vue.component('ActivitySchedulesListPage', ActivitySchedulesListPage);
    Vue.component('DayInactivityIntervalsListPage', DayInactivityIntervalsListPage);
    Vue.component('InactivityIntervalsListPage', InactivityIntervalsListPage);
    Vue.component('ChannelsListPage', ChannelsListPage);
    Vue.component('CranesListPage', CranesListPage);
    Vue.component('MicroeconomicsPage', MicroeconomicsPage);
    Vue.component('MicroeconomicsDetailsPage', MicroeconomicsDetailsPage);
    Vue.component('ConsumptionsPage', ConsumptionsPage);
    Vue.component('ConsumptionsEditPage', ConsumptionsEditPage);
    Vue.component('ConsumptionsSubPacksPage', ConsumptionsSubPacksPage);
    Vue.component('ConsumptionsRoutesPage', ConsumptionsRoutesPage);
    Vue.component('ConsumptionPerformancePage', ConsumptionPerformancePage);
    Vue.component('ConsumptionReasonPage', ConsumptionReasonPage);
    Vue.component('StocksPage', StocksPage);
    Vue.component('PlannedOperationsPage', PlannedOperationsPage);
    Vue.component('LogisticWorkplacePage', LogisticWorkplacePage);
    Vue.component('OperationalPlanSummaryPage', OperationalPlanSummaryPage);
    Vue.component('PlannedOperationsDetailPage', PlannedOperationsDetailPage);
    Vue.component('RelocationsPage', RelocationsPage);
    Vue.component('RelocationsMapPage', RelocationsMapPage);
    Vue.component('ProductRelocationsPage', ProductRelocationsPage);
    Vue.component('ResourcesUsagePage', ResourcesUsagePage);
    Vue.component('ReplacementsPage', ReplacementsPage);
    Vue.component('OperationsChartPage', OperationsChartPage);
    Vue.component('StocksMapPage', StocksMapPage);
    Vue.component('GroupIndicatorsValuePage', GroupIndicatorsValuePage);
    Vue.component('LogPage', LogPage);
    Vue.component('ProductsListPage', ProductsListPage);
    Vue.component('UsersPage', UsersPage);
    Vue.component('RelocationLimitsPage', RelocationLimitsPage);
    Vue.component('ResourceTypesListPage', ResourceTypesListPage);
    Vue.component('LogisticsNetworkPage', LogisticsNetworkPage);
    Vue.component('SitesListPage', SitesListPage);
    Vue.component('TechesListPage', TechesListPage);
    Vue.component('VehiclesListPage', VehiclesListPage);
    Vue.component('UnavailabilityIntervalsListPage', UnavailabilityIntervalsListPage);
    Vue.component('LocationHistoryPage', LocationHistoryPage);
    Vue.component('UsageResourcesPage', UsageResourcesPage);
    Vue.component('LocationHistoryMap', LocationHistoryMap);
    Vue.component('CargoPlacementPage', CargoPlacementPage);
    Vue.component('AuditPage', AuditPage);
}
